import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "utils/api";

interface Heatmap {
  id: number;
  section: {
    id: number;
  };
  body: string;
  imageUrl: string;
  overallReaction: number;
  reactions: [
    {
      reaction: {
        id: number;
        code: string;
        name: string;
        emotionalTone: number;
      };
      value: number;
    }
  ];
}
interface HeatmapSlice {
  isLoading: boolean;
  heatmapQuestions: Heatmap[];
  error: string;
}

const initialState: HeatmapSlice = {
  isLoading: false,
  heatmapQuestions: [],
  error: "",
};

export const getHeatmapQuestions = createAsyncThunk(
  "getHeatmapQuestions",
  async (id: number) => {
    try {
      const response = await axiosInstance.post(
        `/v1/reports/boards/${id}/heatmaps/questions`,
        {}
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);
export const heatmapQuestionsSlice = createSlice({
  initialState,
  name: "heatmapQuestions",
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHeatmapQuestions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHeatmapQuestions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.heatmapQuestions = action.payload;
      })
      .addCase(getHeatmapQuestions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message as string;
      });
  },
});
